module.exports = __webpack_public_path__ + "img/pet-spa.19775202.svg";